import { BarChart, LineChart, PieChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { LabelLayout, UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import { nebalkonEchartsTheme } from './nebalkon-echarts-theme';

export const NEBALKON_ECHARTS_THEME = 'nebalkon';

echarts.use([
  BarChart,
  LineChart,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
]);

echarts.registerTheme(NEBALKON_ECHARTS_THEME, nebalkonEchartsTheme);

export { echarts as nebalkonEcharts };
